module.exports = __webpack_public_path__ + "img/noimage2.cd5604ec.png";